export interface MusicTrack {
  id: string;
  title: string;
  composer: string;
  url: string;
}

/**
 * Curated, built-in background tracks — no user upload. All public-domain
 * compositions, CC BY 3.0 recordings by Kevin MacLeod (attribution shown in
 * the picker UI and on the About page).
 */
export const MUSIC_TRACKS: MusicTrack[] = [
  { id: 'gymnopedie', title: 'Gymnopédie No. 1', composer: 'Erik Satie · perf. Kevin MacLeod (CC BY 3.0)', url: '/music/gymnopedie-no-1.mp3' },
  { id: 'canon-in-d', title: 'Canon in D Major', composer: 'Johann Pachelbel · perf. Kevin MacLeod (CC BY 3.0)', url: '/music/canon-in-d.mp3' },
  { id: 'amazing-grace', title: 'Amazing Grace', composer: 'Traditional · perf. Kevin MacLeod (CC BY 3.0)', url: '/music/amazing-grace.mp3' },
];

export const DEFAULT_MUSIC_TRACK_ID = 'gymnopedie';
/** Explicit opt-out, distinct from "unset" (which falls back to the default track). */
export const NO_MUSIC_ID = 'none';

export const NORMAL_MUSIC_VOLUME = 0.5;
export const DUCKED_MUSIC_VOLUME = 0.12;

/** null/undefined -> default track; NO_MUSIC_ID -> silence; unknown id -> default track. */
export function resolveMusicTrack(id: string | null | undefined): MusicTrack | null {
  const effectiveId = id ?? DEFAULT_MUSIC_TRACK_ID;
  if (effectiveId === NO_MUSIC_ID) return null;
  return MUSIC_TRACKS.find(t => t.id === effectiveId) ?? MUSIC_TRACKS.find(t => t.id === DEFAULT_MUSIC_TRACK_ID) ?? null;
}

/** One fade step toward target, snapping exactly to it once within `step` distance — never overshoots. */
export function stepVolumeToward(current: number, target: number, step = 0.08): number {
  if (Math.abs(current - target) <= step) return target;
  return current < target ? current + step : current - step;
}
